import React from 'react';

/**
 * Helper function to highlight matching text in a query
 */
export const highlightMatch = (
    text: string,
    query: string,
    variant: 'default' | 'header' = 'default',
    menuColor: 'light' | 'dark' = 'dark',
) => {
    const lowerText = text.toLowerCase();
    const lowerQuery = query.toLowerCase();
    const index = lowerText.indexOf(lowerQuery);

    const unmatchedClass =
        variant === 'header' && menuColor === 'light'
            ? 'py-0.5 text-dropdown text-gray-200'
            : variant === 'header' && menuColor === 'dark'
              ? 'py-0.5 text-dropdown text-gray-600'
              : 'py-0.5 text-dropdown text-gray-400';

    const matchedClass =
        variant === 'header' && menuColor === 'light'
            ? 'py-0.5 text-dropdown text-white'
            : 'py-0.5 text-dropdown text-gray-800';

    if (index !== -1) {
        const before = text.slice(0, index);
        const match = text.slice(index, index + query.length);
        const after = text.slice(index + query.length);
        return (
            <>
                <span className={unmatchedClass}>{before}</span>
                <span className={matchedClass}>{match}</span>
                <span className={unmatchedClass}>{after}</span>
            </>
        );
    }
    return <span className={unmatchedClass}>{text}</span>;
};
